"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.validate = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormBlock = _interopRequireDefault(require("../../../components/FormBlock"));

var _max2 = _interopRequireDefault(require("lodash/max"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _keys2 = _interopRequireDefault(require("lodash/keys"));

var _Operator = _interopRequireDefault(require("./Operator"));

var _Value = _interopRequireDefault(require("./Value"));

var _style = _interopRequireDefault(require("./style.css"));

var _operators = _interopRequireDefault(require("./operators.js"));

var _common = _interopRequireDefault(require("../../../styles/common.css"));

var _isInt = _interopRequireDefault(require("validator/lib/isInt"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var validate = function validate(values) {
  var errors = {};

  var setRuleError = function setRuleError(index, field, message) {
    errors.showConditionsRules = errors.showConditionsRules || [];
    errors.showConditionsRules[index] = errors.showConditionsRules[index] || {};
    errors.showConditionsRules[index][field] = message;
  };

  values.showConditionsRules.forEach(function (rule, index) {
    if (!rule.dataConnector) {
      setRuleError(index, 'dataConnector', 'Choose data connector');
    } else if (!rule.operator || rule.operator === '0') {
      setRuleError(index, 'operator', 'Choose operator');
    } else {
      var operatorSettings = (0, _find2.default)(_operators.default[rule.dataConnector.type], {
        code: rule.operator
      });

      if (operatorSettings.isValue) {
        if (operatorSettings.valueType === 'string' && (!rule.value || rule.value === '')) {
          setRuleError(index, 'value', 'Enter some string');
        }

        if (operatorSettings.valueType === 'number' && (!rule.value || !(0, _isInt.default)(rule.value.toString()))) {
          setRuleError(index, 'value', 'Enter valid number');
        }
      }
    }
  });
  return errors;
};

exports.validate = validate;

var ShowConditionsBlock =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ShowConditionsBlock, _React$Component);

  function ShowConditionsBlock() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ShowConditionsBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ShowConditionsBlock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "getNewRuleId", function () {
      return ((0, _max2.default)(_this.props.fields.showConditionsRules.map(function (rule) {
        return rule.id.value;
      })) || 0) + 1;
    });

    _defineProperty(_assertThisInitialized(_this), "addRule", function (event) {
      if (event) {
        event.preventDefault();
      }

      _this.props.fields.showConditionsRules.addField({
        id: _this.getNewRuleId(),
        dataConnector: null,
        operator: '0',
        value: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "deleteRule", function (index) {
      _this.props.fields.showConditionsRules.removeField(index);
    });

    _defineProperty(_assertThisInitialized(_this), "afterDataConnectorChange", function (index) {
      var _this$props$fields$sh = _this.props.fields.showConditionsRules[index],
          operator = _this$props$fields$sh.operator,
          value = _this$props$fields$sh.value; // Nullify operator and value

      operator.onChange('0');
      value.onChange('');
    });

    _defineProperty(_assertThisInitialized(_this), "getOperatorDefinition", function (rule) {
      if (!rule.dataConnector.value || !rule.operator.value) {
        return null;
      }

      return (0, _find2.default)(_operators.default[rule.dataConnector.value.type], {
        code: rule.operator.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getOperatorsTypes", function () {
      return (0, _keys2.default)(_operators.default);
    });

    return _this;
  }

  _createClass(ShowConditionsBlock, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props$fields = this.props.fields,
          showConditionsExpanded = _this$props$fields.showConditionsExpanded,
          showConditionsRules = _this$props$fields.showConditionsRules;
      var DataConnectorsPicker = this.props.DataConnectorsPicker;

      if (!DataConnectorsPicker) {
        return false;
      }

      return _react.default.createElement(_FormBlock.default, {
        title: "Visibility/Logic",
        type: this.props.formBlockType,
        show: showConditionsExpanded.value,
        handleClick: function handleClick(show) {
          return showConditionsExpanded.onChange(show);
        }
      }, showConditionsRules.map(function (rule, index) {
        return _react.default.createElement("div", {
          key: rule.id.value,
          className: 'alert alert-info ' + _style.default.ruleWrapper
        }, _react.default.createElement("a", {
          className: _style.default.delete,
          onClick: _this2.deleteRule.bind(_this2, index),
          title: "Delete condition"
        }, "\xD7"), _react.default.createElement("div", {
          className: !rule.dataConnector.value ? _common.default.lastRow : ''
        }, _react.default.createElement(DataConnectorsPicker, {
          field: rule.dataConnector,
          label: "",
          type: _this2.getOperatorsTypes(),
          afterChange: _this2.afterDataConnectorChange.bind(_this2, index)
        })), _react.default.createElement("div", {
          className: _style.default.rule
        }, _react.default.createElement(_Operator.default, {
          dataConnector: rule.dataConnector.value,
          field: rule.operator
        }), _react.default.createElement(_Value.default, {
          operator: _this2.getOperatorDefinition(rule),
          field: rule.value,
          dataConnector: rule.dataConnector.value,
          getDataConnectorMeta: _this2.props.getDataConnectorMeta
        })));
      }), _react.default.createElement("a", {
        className: "btn btn-default btn-sm",
        onClick: this.addRule
      }, "Add condition"));
    }
  }]);

  return ShowConditionsBlock;
}(_react.default.Component);

exports.default = ShowConditionsBlock;

_defineProperty(ShowConditionsBlock, "propTypes", {
  fields: _propTypes.default.object.isRequired,
  formBlockType: _propTypes.default.string.isRequired,
  DataConnectorsPicker: _propTypes.default.func,
  getDataConnectorMeta: _propTypes.default.func
});